"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addModelProperty = void 0;
const zenithApiPrivate_1 = __importDefault(require("../utils/zenithApiPrivate"));
const config_1 = __importDefault(require("../utils/config"));
const constants_1 = require("../constants");
const { zenithConfigApi } = (0, config_1.default)();
const modelsPropsEndpoint = `${zenithConfigApi}${constants_1.routes.MODEL_PROPERTIES}`;
const addModelProperty = (modelPropertyData) => (zenithApiPrivate_1.default.post(modelsPropsEndpoint, modelPropertyData)
    .then((res) => res.data));
exports.addModelProperty = addModelProperty;
